export default "__VITE_ASSET__DVNKUu4j__"